/* @ts-ignore */
import * as Types from '../generated/graphql.g';

import { PageInfoFragmentDoc } from '../pageInfo/pageInfo.g';
import { useQuery, useInfiniteQuery, useMutation, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData, UseMutationOptions } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: string, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type OrganizationFragment = { __typename: 'OrganizationType', id: string, createdAt: string, updatedAt: string, name: string, organizationType: Types.PublicOrganizationOrganizationTypeChoices, organizationTypeDisplay?: string | null, stytchOrganizationId?: string | null, clientCount?: number | null, userCount?: number | null, employeeCount?: number | null };

export type OrganizationsQueryVariables = Types.Exact<{
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  name_Icontains?: Types.InputMaybe<Types.Scalars['String']['input']>;
  organizationType?: Types.InputMaybe<Types.PublicOrganizationOrganizationTypeChoices>;
  organizationType_In?: Types.InputMaybe<Array<Types.InputMaybe<Types.PublicOrganizationOrganizationTypeChoices>> | Types.InputMaybe<Types.PublicOrganizationOrganizationTypeChoices>>;
  stytchOrganizationId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  createdAt_Gte?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  createdAt_Lte?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  updatedAt_Gte?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  updatedAt_Lte?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  orderBy?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type OrganizationsQuery = { __typename: 'Query', organizations?: { __typename: 'OrganizationTypeConnection', totalCount?: number | null, edges: Array<{ __typename: 'OrganizationTypeEdge', node?: { __typename: 'OrganizationType', id: string, createdAt: string, updatedAt: string, name: string, organizationType: Types.PublicOrganizationOrganizationTypeChoices, organizationTypeDisplay?: string | null, stytchOrganizationId?: string | null, clientCount?: number | null, userCount?: number | null, employeeCount?: number | null } | null } | null>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type OrganizationQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type OrganizationQuery = { __typename: 'Query', organizations?: { __typename: 'OrganizationTypeConnection', edges: Array<{ __typename: 'OrganizationTypeEdge', node?: { __typename: 'OrganizationType', id: string, createdAt: string, updatedAt: string, name: string, organizationType: Types.PublicOrganizationOrganizationTypeChoices, organizationTypeDisplay?: string | null, stytchOrganizationId?: string | null, clientCount?: number | null, userCount?: number | null, employeeCount?: number | null } | null } | null> } | null };

export type DeleteOrganizationMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DeleteOrganizationMutation = { __typename: 'Mutation', deleteOrganization?: { __typename: 'DeleteOrganizationMutation', success?: boolean | null, errors?: Array<string | null> | null } | null };


export const OrganizationFragmentDoc = `
    fragment Organization on OrganizationType {
  id
  createdAt
  updatedAt
  name
  organizationType
  organizationTypeDisplay
  stytchOrganizationId
  clientCount
  userCount
  employeeCount
}
    `;
export const OrganizationsDocument = `
    query Organizations($after: String, $before: String, $first: Int, $last: Int, $offset: Int, $name_Icontains: String, $organizationType: PublicOrganizationOrganizationTypeChoices, $organizationType_In: [PublicOrganizationOrganizationTypeChoices], $stytchOrganizationId: String, $createdAt_Gte: DateTime, $createdAt_Lte: DateTime, $updatedAt_Gte: DateTime, $updatedAt_Lte: DateTime, $orderBy: String) {
  organizations(
    after: $after
    before: $before
    first: $first
    last: $last
    offset: $offset
    name_Icontains: $name_Icontains
    organizationType: $organizationType
    organizationType_In: $organizationType_In
    stytchOrganizationId: $stytchOrganizationId
    createdAt_Gte: $createdAt_Gte
    createdAt_Lte: $createdAt_Lte
    updatedAt_Gte: $updatedAt_Gte
    updatedAt_Lte: $updatedAt_Lte
    orderBy: $orderBy
  ) {
    edges {
      node {
        ...Organization
      }
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    ${OrganizationFragmentDoc}
${PageInfoFragmentDoc}`;

export const useOrganizationsQuery = <
      TData = OrganizationsQuery,
      TError = unknown
    >(
      variables?: OrganizationsQueryVariables,
      options?: Omit<UseQueryOptions<OrganizationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<OrganizationsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<OrganizationsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['Organizations'] : ['Organizations', variables],
    queryFn: fetcher<OrganizationsQuery, OrganizationsQueryVariables>(OrganizationsDocument, variables),
    ...options
  }
    )};

useOrganizationsQuery.getKey = (variables?: OrganizationsQueryVariables) => variables === undefined ? ['Organizations'] : ['Organizations', variables];

export const useInfiniteOrganizationsQuery = <
      TData = InfiniteData<OrganizationsQuery>,
      TError = unknown
    >(
      variables: OrganizationsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<OrganizationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<OrganizationsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<OrganizationsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['Organizations.infinite'] : ['Organizations.infinite', variables],
      queryFn: (metaData) => fetcher<OrganizationsQuery, OrganizationsQueryVariables>(OrganizationsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteOrganizationsQuery.getKey = (variables?: OrganizationsQueryVariables) => variables === undefined ? ['Organizations.infinite'] : ['Organizations.infinite', variables];


useOrganizationsQuery.fetcher = (variables?: OrganizationsQueryVariables) => fetcher<OrganizationsQuery, OrganizationsQueryVariables>(OrganizationsDocument, variables);

export const OrganizationDocument = `
    query Organization($id: ID!) {
  organizations(id: $id) {
    edges {
      node {
        ...Organization
      }
    }
  }
}
    ${OrganizationFragmentDoc}`;

export const useOrganizationQuery = <
      TData = OrganizationQuery,
      TError = unknown
    >(
      variables: OrganizationQueryVariables,
      options?: Omit<UseQueryOptions<OrganizationQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<OrganizationQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<OrganizationQuery, TError, TData>(
      {
    queryKey: ['Organization', variables],
    queryFn: fetcher<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, variables),
    ...options
  }
    )};

useOrganizationQuery.getKey = (variables: OrganizationQueryVariables) => ['Organization', variables];

export const useInfiniteOrganizationQuery = <
      TData = InfiniteData<OrganizationQuery>,
      TError = unknown
    >(
      variables: OrganizationQueryVariables,
      options: Omit<UseInfiniteQueryOptions<OrganizationQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<OrganizationQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<OrganizationQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['Organization.infinite', variables],
      queryFn: (metaData) => fetcher<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteOrganizationQuery.getKey = (variables: OrganizationQueryVariables) => ['Organization.infinite', variables];


useOrganizationQuery.fetcher = (variables: OrganizationQueryVariables) => fetcher<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, variables);

export const DeleteOrganizationDocument = `
    mutation DeleteOrganization($id: ID!) {
  deleteOrganization(id: $id) {
    success
    errors
  }
}
    `;

export const useDeleteOrganizationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteOrganizationMutation, TError, DeleteOrganizationMutationVariables, TContext>) => {
    
    return useMutation<DeleteOrganizationMutation, TError, DeleteOrganizationMutationVariables, TContext>(
      {
    mutationKey: ['DeleteOrganization'],
    mutationFn: (variables?: DeleteOrganizationMutationVariables) => fetcher<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>(DeleteOrganizationDocument, variables)(),
    ...options
  }
    )};


useDeleteOrganizationMutation.fetcher = (variables: DeleteOrganizationMutationVariables) => fetcher<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>(DeleteOrganizationDocument, variables);
